var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('Header'),_c('div',{staticClass:"mx-auto max-w-screen-lg px-3 lg:max-w-screen-2xl lg:px-8 xl:max-w-screen-xl xl:px-4 pt-4"},[_c('breadcrumb'),_c('div',{staticClass:"grid grid-cols-5 gap-7 pb-10 pt-4"},[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }